import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Tab from './ReportsTab';
import Form from './ReportForm';
import Test from './Test';

function ReportsRouter() {
  return (
    <Switch>
      <Route exact path="/reports" component={Tab} />
      {/*<Route exact path="/reports/new" component={Form} />*/}
      <Route exact path="/reports/:id" component={Form} />
      <Redirect to="/reports" />
    </Switch>
  );
}

export default ReportsRouter;



// WEBPACK FOOTER //
// ./src/containers/Reports/index.js